// Mock data and functions for frontend-only testing

export const mockTestimonials = [
  {
    id: 1,
    order: 8,
    name: "Rajan Chawla",
    programme: "Diploma (Full-Time)",
    year: "2024",
    profession: "Theatre Actor & Director",
    text: "I consider myself lucky to have been trained directly by Barry Sir. I remember in 1999 when I started learning from him, I was painfully shy and a wimp but, in a few months, I could feel the metamorphosis in me. His style of teaching encourages you towards self-awareness, to understand your past, present and future aspirations which eventually help you to understand and perform characters honestly. It also helps you to become more confident in life. He is the father of Theatre-In-Education in India. I have seen his work in TIE changing the lives of innumerable children and teachers alike.",
    image: "/images/testimonials/Rajan-Chawla.png",
  },
  {
    id: 2,
    name: "Anisha",
    order: 9,
    programme: "Weekend (Part-Time)",
    year: "2023",
    profession: "Actor",
    text: "An experience worth exploring I had one of the most fabulous, fulfilling and wholesome experiences of my life with this workshop. It started with \"Know Yourself\" and that is still going on. I have discovered things about myself that somewhere I knew but was never able to express. Barry, actually, magically creates a space where one feels so safe to delve into and open up one's potential. More so it's actually magical the way one could feel camaraderie and fun, and yet appreciate other participants and be awestruck and learn from their performances and talent. One is only sad when it's over and one doesn't want to let go. The festival was the cherry on the cake. The kind of preparation, feedback and involvement that it entailed was life invigorating and precious.",
    image: "/images/testimonials/Anisha.png",
  },
  {
    id: 3,
    name: "Aditya Kumar",
    order: 5,
    programme: "Diploma (Full-Time)",
    year: "2024",
    profession: "Actor",
    text: "Barry Sir ki teaching kafi organic hoti hai.. kabhi lagta nahi ki aap class mein baithe ho",
    image: "/images/testimonials/Aditya-Kumar.jpg",
  },
  {
    id: 4,
    name: "Kamal Batra",
    order: 6,
    programme: "Diploma (Full-Time)",
    year: "2024",
    profession: "Actor",
    text: "I loved the space they created for actors to exchange ideas",
    image: "/images/testimonials/Kamal-Batra.jpg",
  },
  {
    id: 5,
    name: "Rashi Kaushal",
    order: 10,
    programme: "Diploma (Full-Time)",
    year: "2024",
    profession: "Actor",
    text: "Barry John's way of teaching is ingenious, intense and fun at the same time.",
    image: "/images/testimonials/Rashi-Kaushal.png",
  },
  {
    id: 6,
    order: 2,
    name: "Vishal Bhardwaj",
    programme: "Diploma (Full-Time)",
    year: "2024",
    profession: "Film Director & Producer",
    text: "Barry is an exceptional director and also a prolific teacher. He has truly nurtured and cultivated nany of India's finest actors through his insightful teaching and training programs. His contributions to the cinema of India is unparalleled and a testimony to his skill and vigorous talent.",
    image: "/images/testimonials/Vishal-Bhardwaj.jpg",
  },
  {
    id: 7,
    name: "Atul Mongia",
    order: 7,
    programme: "Diploma (Full-Time)",
    year: "2024",
    profession: "Acting Coach & Director",
    text: "It's great to know that the eminent teacher Mr. Barry John is looking to teach again. This is a great opportunity for acting students and aficionados alike to learn from one of the best. My journey in the field of art started ith Barry, first as his student and then as a teacher in his academy. I have learnt a great deal from my first acting uru and I would urge everyone to not miss this chance to get educated by this path-breaking master.",
    image: "/images/testimonials/Atul-Mongia.jpeg",
  },
  {
    id: 8,
    name: "Shilpa Shukla",
    order: 4,
    programme: "Diploma (Full-Time)",
    year: "2024",
    profession: "Film & TV Actress",
    text: "They say that when the student is ready the teacher appears. Barry John's presence in the founding years of my acting life has had an nmense impact on how 1 percewed acting- organic and simple. And simple seems effortless but it's not easy. He is that rare teacher who has realised the truth of how to shape an actor so that he/ she is ready to receive characters that come our way. le is a unique teacher with gifts and methods that are indispensable. He is a jewel, a rare gem, the greatest teacher of acting that our country has seen. I am so fortunate to have been trained under his guidance.",
    image: "/images/testimonials/Shilpa-Shukla.avif",
  },
  {
    id: 9,
    order: 3,
    name: "Lillete Dubey",
    programme: "Diploma (Full-Time)",
    year: "2024",
    profession: "Theatre & Film Actress",
    text: "I've always said that I went to the Barry John School of Drama before he had a School of Drama! Because I really don't believe any drama school could have taught me more than I learnt in those wonderfully intense 15 years, working with him, over 25 odd completely different plays. He is my mentor and whatever little I know of theatre today is a gift from him. He ignited a passion in me that still burns bright even after 45 years! An amazing and patient teacher who encourages you to explore, grow and discover your own potential and range, he's the one who taught me my most important lesson; to be true, to be real, to be natural and to simply become the character, without artifice and show. I owe him a huge debt of gratitude for transforming my life.",
    image: "/images/testimonials/Lillete-Dubey.jpg",
  },
  {
    id: 10,
    order: 1,
    name: "Manoj Bajpayee",
    programme: "Diploma (Full-Time)",
    year: "2024",
    profession: "Film Actor",
    text: "My best wishes to The Free Birds Collective and my teacher-mentor and elder Mr. Barry John!! My life story will be nothing without the mention of Barry as he is the one who instilled self-belief and confidence in me as a person and a theatre activist. I am very assured that all who will be part of this endeavour will learn greatly from the genius and expertise of Mr. Barry John!!❤️",
    image: "/images/testimonials/manoj-bajpayee.jpg",
  },
];

export const mockFAQs = [
  {
    id: 1,
    question: "Is this suitable for beginners?",
    answer:
      "Yes. Both programmes are designed for serious learners—whether you're starting fresh or building on existing experience. What matters is your commitment to the work, not where you're starting from.",
  },
  {
    id: 2,
    question: "How are admissions decided?",
    answer:
      "Admissions are processed on a rolling basis. We look for commitment, seriousness, and genuine interest in professional acting. Once you apply, our admissions team will contact you within 24 hours to discuss next steps.",
  },
  {
    id: 3,
    question: "What is the weekly schedule like?",
    answer:
      "The Diploma (Full-Time) programme runs Monday to Friday from 8am to 4pm. The Weekend (Part-Time) programme runs on Saturdays and Sundays from 9am to 1:30pm.",
  },
  {
    id: 4,
    question: "What is the batch size?",
    answer:
      "Each batch has 20 students to ensure personalized attention and quality feedback. This limited batch size maintains the intensive, hands-on nature of the training.",
  },
  {
    id: 5,
    question: "Is there a certificate on completion?",
    answer:
      "Yes. The Diploma programme awards a Diploma in Film & Theatre Acting. The Weekend programme awards a Certificate in Film & Theatre Acting—both issued by The Free Birds Collective.",
  },
  {
    id: 6,
    question: "Where is the training conducted?",
    answer:
      "All training is conducted on-premise at First floor, Global Chambers, 101, near Infinity Mall, Veera Desai Industrial Estate, Andheri West, Mumbai, Maharashtra 400053. Both programmes are fully in-person—there is no online option.",
  },

  {
    id: 8,
    question: "Can I switch between programmes?",
    answer:
      "No. The two programmes have different structures and time commitments. If you're unsure which fits your schedule, our admissions team can help you decide during the application process.",
  },
];

// Mock form submission function
export const mockSubmitApplication = async (formData, programmeType) => {
  console.log("Mock submission:", { programmeType, formData });

  // Simulate API delay
  await new Promise((resolve) => setTimeout(resolve, 1000));

  // Store in localStorage for demo purposes
  const applications = JSON.parse(localStorage.getItem("applications") || "[]");
  const newApplication = {
    id: Date.now(),
    programmeType,
    ...formData,
    submittedAt: new Date().toISOString(),
  };
  applications.push(newApplication);
  localStorage.setItem("applications", JSON.stringify(applications));

  return {
    success: true,
    message:
      "Application submitted successfully! We'll contact you within 24 hours.",
  };
};
